import { getAuthToken, isLoginInProgress, logout } from '../providers/AuthProvider/authService';

import { client } from './generated-evs/client.gen';

// Import this file to ensure client configuration is loaded
// This should be imported early in the application lifecycle

// Configure the default client for EVS API
// This client will be used by all generated SDK functions
client.setConfig({
  baseUrl: '/api',
});

// Configure request interceptor for authentication
client.interceptors.request.use((config) => {
  const authToken = getAuthToken();

  if (!authToken) {
    return config;
  }

  config.headers.set('Authorization', `Bearer ${authToken}`);

  return config;
});

// Configure response interceptor for handling 401 errors.
// Skip logout redirect while login is in progress to prevent
// race conditions where concurrent 401s interrupt the login flow.
client.interceptors.response.use((response) => {
  if (response.status === 401 && !isLoginInProgress()) {
    logout();
  }

  return response;
});
